/**
 * Extracts program name from source
 * @param eventSource - example: "type=some-type;actor=user@gmail.com;programs=Program Name;dispatchedBy=site"
 * should return "Program Name"
 */
export function getProgramNameFromSource(eventSource: string) {
    if (!eventSource) return '';

    const parts = eventSource.split(';');

    for (const part of parts) {
        const [key, value] = part.split('=');
        if (key.trim() === 'programs') {
            return value?.trim() || '';
        }
    }

    return '';
}
